import axios from 'axios';
import { BASE_URL } from './helpers';

export type FeatureKey =
  | 'studio'
  | 'generate'
  | 'series'
  | 'docs'
  | 'builder'
  | 'chat'
  | 'generators'
  | 'datasets'
  | 'training'
  | 'pipeline_manager'
  | 'archive'
  | 'upload_media'
  | 'admin';

export interface UserAccess {
  user_id: string;
  is_admin: boolean;
  allowed_features: FeatureKey[];
  visible_tabs: string[];
}

async function getMyAccess(): Promise<UserAccess> {
  const res = await axios.get<UserAccess>(`${BASE_URL}/me/access`);
  return res.data;
}

const AccessAPI = { getMyAccess };

export default AccessAPI;
